import { Outlet } from "react-router-dom";
import { Box, Container } from "@chakra-ui/react";
import NavBar from "../components/NavBar";

export default function RootLayout() {
  return (
    <>
      <Box w="100%">
        <Container maxWidth="620px" px={[5, 6]}>
          <NavBar />
        </Container>
      </Box>
      <Container as="main" maxWidth="620px" px={[5, 6]}>
        <Outlet />
      </Container>
    </>
  );
}
